import React from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import "./SEOPage.css";

const DistrictSEOPage = () => {
  const { district } = useParams();

  const districtName = district
    ?.split("-")
    .map(
      word =>
        word.charAt(0).toUpperCase() +
        word.slice(1)
    )
    .join(" ");

  return (
    <>
      <Helmet>

        <title>
          IVF Treatment for Patients from {districtName} |
          Amaanat IVF Ambala
        </title>

        <meta
          name="description"
          content={`Patients from ${districtName} visit Amaanat IVF Ambala for IVF Treatment, IUI, ICSI, infertility treatment, gynaecology, pediatrics and dietician services.`}
        />

        <meta
          name="keywords"
          content={`
          IVF Treatment in ${districtName},
          IVF Centre near ${districtName},
          Fertility Clinic near ${districtName},
          IVF Specialist near ${districtName},
          Test Tube Baby Centre near ${districtName},
          Best IVF Centre in Haryana,
          IVF Treatment in Ambala,
          IUI Treatment,
          ICSI Treatment,
          Male Infertility Treatment,
          Female Infertility Treatment
          `}
        />

      </Helmet>

      <div className="seo-page">

        {/* HERO */}

        <section className="seo-hero">
          <div className="container">

            <h1>
              IVF Treatment for Patients from {districtName}
            </h1>

            <p>
              Many patients from {districtName} choose
              Amaanat IVF Clinic Ambala for advanced
              fertility treatment, IVF, IUI, ICSI,
              gynaecology, pediatrics and fertility
              nutrition services.
            </p>

            <a
              href="/bookappointment"
              className="hero-btn text-decoration-none"
            >
              Book Consultation
            </a>

          </div>
        </section>

        {/* CONTENT */}

        <section className="content-section">
          <div className="container">

            <h2>
              Why Patients from {districtName} Visit
              Amaanat IVF Ambala?
            </h2>

            <p>
              Couples from {districtName} often travel
              to Ambala for fertility treatment due to
              the availability of experienced fertility
              specialists, advanced IVF laboratory
              facilities and personalized care.
            </p>

            <p>
              Our fertility centre offers IVF Treatment,
              IUI Treatment, ICSI Treatment, Male
              Infertility Treatment, Female Infertility
              Treatment, Pregnancy Care and
              Gynaecological Services under one roof.
            </p>

          </div>
        </section>

        {/* SERVICES */}

        <section className="content-section bg-white">
          <div className="container">

            <h2>
              Services Available for Patients from
              {districtName}
            </h2>

            <div className="row">

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>IVF Treatment</h4>
                  <p>
                    Advanced IVF procedures with modern
                    fertility technologies.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>IUI Treatment</h4>
                  <p>
                    Affordable and effective fertility
                    treatment option.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>ICSI Treatment</h4>
                  <p>
                    Specialized treatment for severe
                    male infertility cases.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>Gynaecology</h4>
                  <p>
                    PCOS treatment, pregnancy care and
                    women's healthcare.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>Pediatrics</h4>
                  <p>
                    Child healthcare and vaccination
                    services.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>Dietician</h4>
                  <p>
                    Fertility nutrition and pregnancy
                    diet counseling.
                  </p>
                </div>
              </div>

            </div>

          </div>
        </section>

        {/* FAQ */}

        <section className="content-section">
          <div className="container">

            <h2>
              Frequently Asked Questions
            </h2>

            <div className="faq-item">
              <h5>
                How far is Amaanat IVF from {districtName}?
              </h5>
              <p>
                Our clinic is located in Ambala and is
                easily accessible for patients from
                {districtName}.
              </p>
            </div>

            <div className="faq-item">
              <h5>
                Do patients from {districtName}
                come for IVF treatment?
              </h5>
              <p>
                Yes, many couples from {districtName}
                visit our clinic for fertility treatment
                and reproductive healthcare.
              </p>
            </div>

          </div>
        </section>

        {/* CTA */}

        <section className="container pb-5">
          <div className="cta-section">

            <h2>
              Schedule Your Consultation
            </h2>

            <p>
              Begin your fertility journey with
              Amaanat IVF Clinic Ambala.
            </p>

            <a
              href="/bookappointment"
              className="cta-btn text-decoration-none"
            >
              Book Appointment
            </a>

          </div>
        </section>

      </div>
    </>
  );
};

export default DistrictSEOPage;